import { createContext, useCallback, useContext, useEffect, useState } from 'react'

// Seletor de tema do sistema — 3 aparências (padrão inspirado no Sol Magazine):
//   claro  → tudo claro (inclusive o menu lateral)
//   escuro → tudo escuro
//   auto   → MISTO: menu escuro + conteúdo claro (o visual original "mesclado")
// O valor aplicado em <html data-theme> é 'light' | 'dark' | 'misto'.
const KEY = 'tc-theme'

function resolve(mode) {
  if (mode === 'dark') return 'dark'
  if (mode === 'light') return 'light'
  return 'misto' // auto = mesclado
}
export function applyTheme(mode) {
  const eff = resolve(mode)
  const el = document.documentElement
  el.setAttribute('data-theme', eff)
  el.style.colorScheme = eff === 'dark' ? 'dark' : 'light'
  return eff
}

const ThemeCtx = createContext({ mode: 'auto', effective: 'misto', setMode: () => {} })

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => localStorage.getItem(KEY) || 'auto')
  const [effective, setEffective] = useState(() => resolve(localStorage.getItem(KEY) || 'auto'))

  const setMode = useCallback((m) => {
    localStorage.setItem(KEY, m)
    setModeState(m)
    setEffective(applyTheme(m))
  }, [])

  useEffect(() => { setEffective(applyTheme(mode)) }, [mode])

  return <ThemeCtx.Provider value={{ mode, effective, setMode }}>{children}</ThemeCtx.Provider>
}

export const useTheme = () => useContext(ThemeCtx)
